import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
// Sections for this page
import image1 from "assets/img/ngo/image1.png";
import image2 from "assets/img/ngo/image2.png";
import image3 from "assets/img/ngo/image3.png";
import image4 from "assets/img/ngo/image4.png";

const useStyles = makeStyles(styles);
const tileData = [
    {
      img: image1,
      title: 'संस्था',
      description: 'संक्षिप्त परिचय',
    },
    {
      img: image2,
      title: 'संस्था',
      description: 'संक्षिप्त परिचय',
    },
    {
      img: image3,
      title: 'संस्था',
      description: 'संक्षिप्त परिचय',
    },
    {
      img: image4,
      title: 'संस्था',
      description: 'संक्षिप्त परिचय',
    },

  ];

export default function ProductSection() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} style={{ textAlign: 'left' }}>
          <div style={{ paddingLeft: '10px',color: "#134c7a", margin: 0, borderLeft: "5px solid #134c7a" }}>
            <small>सम्बन्धित संस्था</small>
            <span><h3 className={classes.title} style={{ marginTop: '-10px', color: '#134c7a'}}>गैरसरकारी संस्था</h3></span>
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={4} style={{ textAlign: 'left' }}>
          <h5 className={classes.description} style={{ textAlign: 'left', color: '#333', padding: '10px' }}>
            गैरसरकारी संस्था शासकीय संरचनाको एउटा महत्वपूर्ण साझेदार हो । नाफारहित, स्वयंसेवी भावना, स्वतन्त्र समाजका विभिन्न सरोकारहरूमा एकल र साझेदार संस्थाको रूपमा काम गर्ने उद्देश्यले गैर सरकारी संस्थाहरूको स्थापना भएको हुन्छ । राज्यको विशेष पहुँच पुग्न नसकेको वा सरकारी संरचनाको कार्य मात्रले अपुग भएका क्षेत्र, वर्ग, समूह र मुद्दाहरूको हित प्रवद्र्धनका लागि स्वतःस्फूर्त रूपमा स्थापना र सञ्चालन हुने आपसी सद्भाव तथा समझदारीको आधारमा आफ्ना कार्यक्रमहरू अगाडि बढाउने हुँदा सरकारी क्षेत्रको तुलनामा गैरसरकारी संस्था बढी व्यावहारिक, सक्रिय, गतिशील, प्रभावकारी तथा कर्तव्यनिष्ठ भई कुनै पनि राष्ट्रको विकास र उत्थानमा आफ्ना विविध कार्यक्रमहरूको माध्यमद्वारा महत्वपूर्ण भूमिका निर्वाह गर्न सक्छन् भन्ने मान्यता छ ।
          </h5>
        </GridItem>
        <GridContainer xs={12} sm={12} md={8} style={{ marginTop: '20px' }}>
          <div className={classes.root}>
            <a href='/ngo'>
            <GridList cellHeight={180} className={classes.gridList}>
              {tileData.map((tile) => (
                <GridListTile key={tile.img} style={{ padding: '10px', border: '5px solid #999' }}>
                  <img src={tile.img} alt={tile.title}/>
                  {/*<GridListTileBar
                    title={tile.title}
                    subtitle={<span>{tile.description}</span>}
                    actionIcon={
                      <IconButton aria-label={`info about ${tile.title}`} className={classes.icon}>
                        <InfoIcon />
                      </IconButton>
                    }
                  />*/}
                </GridListTile>
              ))}
            </GridList>
            </a>
          </div>
        </GridContainer>
        <Button href="/ngo" style={{ margin: 'auto', marginTop: '15px' }} color="primary">थप जानकारी</Button>
      </GridContainer>
    </div>
  );
}
